module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fb-Ge-Hc-Ib-Jb.1229c9ed.png";